import React from 'react'

export const genericMemo: <ComponentType>(c: ComponentType) => ComponentType = React.memo
